.container {
    background-color: var(--static-background-strong);
    margin-top: 16px;
    /* padding: 24px;
    border-radius: 8px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1); */
  }
  
  .header {
    margin-bottom: 16px;
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }
  
  .title {
    color: var(--static-text-strong);
    font-size: var(--fs-small);
    font-weight: 600;
    line-height: normal;
  }
  
  .buttonGroup {
    display: flex;
    gap: 8px;
    margin-bottom: 16px;
  }
  
  .button {
    display: flex;
    align-items: center;
    padding: 8px 16px;
    border-radius: 9999px;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.2s ease;
    border: none;
  }
  
  .buttonActive {
    background-color: var(--static-background-strong);
    border: 1px solid var(--static-divider-standard);
    color: var(--static-text-strong);
  }
  
  .buttonInactive {
    background-color: #f3f4f6;
    color: #6b7280;
  }
  
  .colorIndicator {
    width: 12px;
    height: 12px;
    margin-right: 8px;
    border-radius: 2px;
  }
  
  .currentColor {
    background-color: var(--color-primary);
  }
  
  .previousColor {
    background-color: var(--static-background-inverse-strong);
  }
  
  .chartContainer {
    height: 256px;
    margin-top: 16px;
  }
  
  .tooltip {
    background-color: var(--static-background-strong);
    padding: 16px;
    border-radius: 8px;
    border: 1px solid var(--static-divider-standard);
    min-width: 200px;
  }
  
  .tooltipTitle {
    font-weight: 500;
    color: #333;
    margin-bottom: 8px;
  }
  
  .tooltipContent {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
  
  .tooltipRow {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  .tooltipLabel {
    color: #6b7280;
  }
  
  .tooltipValue {
    font-weight: 600;
  }
  
  .tooltipValueHighlighted {
    font-weight: 600;
    background-color: var(--static-background-strong);
    padding: 4px 8px;
    border-radius: 4px;
  }

  .chartYAxis text {
    font-size: var(--fs-small);
    line-height: 1rem;
    fill: var(--static-text-weak);
  }
  
  .chartLeftYAxis {
    transform: translateX(-0.5rem);
  }
  
  .chartLeftYAxis g text {
    text-anchor: end;
  }